
<div #parentDiv  class="text-center w-100 h-100" >
  <p-knob  [(ngModel)]="inject.data.values[0][0]" [min]="limits[0]" [max]="limits[1]" [size]="size" [disabled]="true"
  [valueColor]="color"  [textClass]="class"  [comprareValue]="comprareValue" [ngStyle]="getStyle()"></p-knob>

</div>